import React from 'react';
import ServicePageTemplate from '../components/ServicePageTemplate';
import {
  digitalMarketingHub,
  seoHub,
  aiSeoPage,
  llmOptimizationPage,
  ecommerceSeoPage,
  technicalSeoPage,
  seoCopywritingPage,
  socialMediaPage,
  ppcPage,
  brandStrategyPage,
} from '../data/marketingServicesData';

export const DigitalMarketingHub = () => (
  <ServicePageTemplate data={digitalMarketingHub} testIdSlug="digital-marketing" />
);

export const SEOHub = () => (
  <ServicePageTemplate data={seoHub} testIdSlug="seo-hub" />
);

export const AISEOPage = () => (
  <ServicePageTemplate data={aiSeoPage} testIdSlug="ai-seo" />
);

export const LLMOptimizationPage = () => (
  <ServicePageTemplate data={llmOptimizationPage} testIdSlug="llm-optimization" />
);

export const EcommerceSEOPage = () => (
  <ServicePageTemplate data={ecommerceSeoPage} testIdSlug="ecommerce-seo" />
);

export const TechnicalSEOPage = () => (
  <ServicePageTemplate data={technicalSeoPage} testIdSlug="technical-seo" />
);

export const SEOCopywritingPage = () => (
  <ServicePageTemplate data={seoCopywritingPage} testIdSlug="seo-copywriting" />
);

export const SocialMediaPage = () => (
  <ServicePageTemplate data={socialMediaPage} testIdSlug="social-media" />
);

export const PPCPage = () => (
  <ServicePageTemplate data={ppcPage} testIdSlug="ppc" />
);

export const BrandStrategyPage = () => (
  <ServicePageTemplate data={brandStrategyPage} testIdSlug="brand-strategy" />
);
